(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gl4mour-offer"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('gl4mour-offer')) {
customElements.define('gl4mour-offer', class extends HTMLElement {
connectedCallback() {
this.end = Date.parse(this.dataset.end);
this.tick = () => {
const remaining = Math.max(0, Math.ceil((this.end - Date.now()) / 1000));
if (!Number.isFinite(this.end) || remaining <= 0) {
this.hidden = true;
clearInterval(this.interval);
window.dispatchEvent(new Event('resize'));
return;
}
this.querySelector('[data-hours]').textContent = String(Math.floor(remaining / 3600)).padStart(2, '0');
this.querySelector('[data-minutes]').textContent = String(Math.floor(remaining / 60) % 60).padStart(2, '0');
this.querySelector('[data-seconds]').textContent = String(remaining % 60).padStart(2, '0');
this.querySelector('[role="timer"]').hidden = false;
};
this.tick();
if (!this.hidden) this.interval = setInterval(this.tick, 1000);
this.querySelector('button').onclick = () => {
this.hidden = true;
clearInterval(this.interval);
window.dispatchEvent(new Event('resize'));
};
}
disconnectedCallback() { clearInterval(this.interval); }
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
